const t = {
  name: "BarChartFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 2C17.8954 2 17 2.89543 17 4V20C17 21.1046 17.8954 22 19 22H21C22.1046 22 23 21.1046 23 20L23 4C23 2.89543 22.1046 2 21 2L19 2Z" fill="currentColor"/>
<path d="M3 14C1.89543 14 1 14.8954 1 16L1 20C1 21.1046 1.89543 22 3 22H5C6.10457 22 7 21.1046 7 20V16C7 14.8954 6.10457 14 5 14H3Z" fill="currentColor"/>
<path d="M11 8C9.89543 8 9 8.89543 9 10L9 20C9 21.1046 9.89543 22 11 22H13C14.1046 22 15 21.1046 15 20V10C15 8.89543 14.1046 8 13 8L11 8Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as BarChartFilled
};
